export default __webpack_public_path__ + "static/media/181.bf7c4abc.jpg";